// extracted by mini-css-extract-plugin
export var active = "MainMenu-module--active--6809b";
export var component = "MainMenu-module--component--430d1";
export var disabled = "MainMenu-module--disabled--68648";
export var fadePop = "MainMenu-module--fade-pop--e7e98";
export var growHeightIn = "MainMenu-module--grow-height-in--45d59";
export var menu_item = "MainMenu-module--menu_item--1a16e";